import { Avatar, OrgAvatar } from '../Avatar';
import { Tooltip } from '../Input2';

interface DetailHeaderOrgProps {
  name: string | undefined;
  linkedinSlug: string | undefined;
  pictureUrl: string | null | undefined;
}
export const DetailHeaderOrg = ({ name, linkedinSlug, pictureUrl }: DetailHeaderOrgProps) => {
  const url = linkedinSlug ? `https://www.linkedin.com/company/${linkedinSlug}` : undefined;
  return (
    <div className="flex flex-1 gap-4">
      {url && (
        <Tooltip tooltip="Open in LinkedIn">
          <a href={url} target="_blank">
            <OrgAvatar name={name} src={pictureUrl} className="size-10" shape="circle" />
          </a>
        </Tooltip>
      )}
      {!url && <OrgAvatar name={name} src={pictureUrl} className="size-10" shape="circle" />}

      <div className="flex flex-1 w-0 flex-col gap-1">
        <div className="line-clamp-1 min-h-[30px] max-h-[30px] overflow-hidden text-ellipsis text-xl/[30px] font-medium text-(--header-text-color)">
          {name}
        </div>
      </div>
    </div>
  );
};

export const DetailHeaderOrgLoading = () => (
  <div className="flex flex-1 gap-4">
    <Avatar srcs={[]} className="size-10" alt="" shape="circle" />

    <div className="flex flex-1 w-0 flex-col gap-1">
      <div className="min-h-[30px] max-h-[30px]" />
      <div className="h-5" />
      <div className="h-6" />
    </div>
  </div>
);
